module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n    <div>\n      <h4>Frontend Version:</h4>\n      <pre class=\"splash-message\">{{frontendVersionObj | json}}</pre>\n    </div>\n    <div>\n      <h4>Backend Version:</h4>\n      <pre class=\"splash-message\">{{backendVersionObj | json}}</pre>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/version/version.component.html
// module id = xhPN
// module chunks = 0